var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadlineContainer',{attrs:{"headline":"Content","breadcrumbs":[{text: 'Content'}]}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('ContentPortalList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }